import { render, staticRenderFns } from "./whitelist.vue?vue&type=template&id=5404cac8&scoped=true"
import script from "./whitelist.vue?vue&type=script&lang=js"
export * from "./whitelist.vue?vue&type=script&lang=js"
import style0 from "./whitelist.vue?vue&type=style&index=0&id=5404cac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5404cac8",
  null
  
)

export default component.exports